var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"chartContainer",staticStyle:{"background-color":"white"}},[_c('fade-transition',[(_vm.show.chart)?_c('bar-chart',{attrs:{"height":_vm.chartHeight,"width":_vm.chartHeight,"chart-data":_vm.chart,"options":_vm.bar_options}}):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-244b23ab","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Statistics.vue
// module id = null
// module chunks = 